import { OrderItem } from './OrderItem';
/**
 * @KotlinClass com.baomidou.mybatisplus.extension.plugins.pagination.Page
 */
export class Page<T> {
    /**
     * @NomosDefineDescription ""
     * @NomosDefineType {"family":"array","elementType":{"family":"generic","name":"T","index":0}}
     * @NomosGenericElements ["T"]
     */
    records!: Array<T>;
    /**
     * @NomosDefineDescription ""
     * @NomosDefineType {"family":"number"}
     * @NomosGenericElements ["T"]
     */
    total!: number;
    /**
     * @NomosDefineDescription ""
     * @NomosDefineType {"family":"number"}
     * @NomosGenericElements ["T"]
     */
    size!: number;
    /**
     * @NomosDefineDescription ""
     * @NomosDefineType {"family":"number"}
     * @NomosGenericElements ["T"]
     */
    current!: number;
    /**
     * @NomosDefineDescription ""
     * @NomosDefineType {"family":"array","elementType":{"family":"object","className":"com.baomidou.mybatisplus.core.metadata.OrderItem","elementTypes":[]}}
     * @NomosGenericElements ["T"]
     */
    orders!: Array<OrderItem>;
    /**
     * @NomosDefineDescription ""
     * @NomosDefineType {"family":"boolean"}
     * @NomosGenericElements ["T"]
     */
    optimizeCountSql!: boolean;
    /**
     * @NomosDefineDescription ""
     * @NomosDefineType {"family":"boolean"}
     * @NomosGenericElements ["T"]
     */
    isSearchCount!: boolean;
    /**
     * @NomosDefineDescription ""
     * @NomosDefineType {"family":"boolean"}
     * @NomosGenericElements ["T"]
     */
    hitCount!: boolean;
    /**
     * @NomosDefineDescription ""
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements ["T"]
     */
    countId!: string;
    /**
     * @NomosDefineDescription ""
     * @NomosDefineType {"family":"number"}
     * @NomosGenericElements ["T"]
     */
    maxLimit!: number;
}
